// ContactSection.jsx
import React, { useState } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const contactInfo = [
    {
      icon: <Phone className="text-blue-600" />,
      label: "+91 80120 03040",
    },
    {
      icon: <Mail className="text-green-600" />,
      label: "selvasiasacademy@gmail.com",
    },
    {
      icon: <MapPin className="text-red-600" />,
      label:
        "No.16/148, Avvai St, Tiruvalleeswarar Nagar, Thirumangalam, Anna Nagar West Extension, Chennai, Tamil Nadu 600040",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      toast.warning("Please fill in all fields!", { position: "top-center" });
      return;
    }

    // Sending email through EmailJS
    emailjs
      .send(
        "service_79a9w7l", // 👉 Replace with your actual EmailJS Service ID
        "template_cb2095w", // 👉 Replace with your EmailJS Template ID
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        },
        "4GIcO68dwFlNFdUyb" // 👉 Replace with your EmailJS Public Key
      )
      .then(
        () => {
          toast.success("Message sent successfully!", {
            position: "top-center",
          });
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error("EmailJS Error:", error);
          toast.error("Failed to send message. Please try again later.", {
            position: "top-center",
          });
        }
      );
  };

  return (
    <section id="contact" className="w-full bg-gray-50 py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Left Side - Contact Form */}
        <div className="bg-white rounded-2xl shadow-md p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Name */}
            <div>
              <label className="block text-sm font-semibold text-red-800 mb-1">
                Name
              </label>
              <input
                type="text"
                placeholder="Your Full Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-semibold text-red-800 mb-1">
                Email
              </label>
              <input
                type="email"
                placeholder="Your Email Address"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>

            {/* Message */}
            <div>
              <label className="block text-sm font-semibold text-red-800 mb-1">
                Message
              </label>
              <textarea
                rows="4"
                placeholder="Write your message here..."
                value={formData.message}
                onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              ></textarea>
            </div>

            {/* Button */}
            <button
              type="submit"
              className="w-full bg-red-700 hover:bg-red-800 text-white font-semibold py-2 px-6 rounded-lg shadow-md transition duration-300"
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Right Side - Contact Info + Map */}
        <div className="bg-white rounded-2xl shadow-md p-8">
          <h2 className="text-xl font-bold text-red-800 mb-6">
            Contact Information
          </h2>

          <ul className="space-y-4 text-gray-700">
            {contactInfo.map((item, index) => (
              <li key={index} className="flex items-center gap-3">
                {item.icon}
                <span>{item.label}</span>
              </li>
            ))}
          </ul>

          {/* Google Map Embed */}
          <div className="mt-6 w-full h-60 rounded-lg overflow-hidden">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.2280228050267!2d80.19263757409823!3d13.084730187241064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5264038623730d%3A0x390567aebf276e5a!2s16%2F148%2C%20Avvai%20St%2C%20Tiruvalleeswarar%20Nagar%2C%20Anna%20Nagar%20West%20Extension%2C%20Chennai%2C%20Tamil%20Nadu%20600040!5e0!3m2!1sen!2sin!4v1759053903095!5m2!1sen!2sin"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              className="border-0"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
